"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TREND_AXIS_LABELS = exports.TREND_ENGINE_FACETS = exports.TREND_AXES = void 0;
/**
 * The clustered trend axes, mirroring the database `TrendFacet` enum.
 *
 * The web app cannot import the database package, so this literal is the list it builds the
 * facet selector from; an api-side contract test asserts it stays equal to the enum. That test
 * is what makes silent drift impossible — the previous hand-maintained web list shipped without
 * `hook`, and 60 of 94 clusters were unselectable on the board with nothing failing.
 */
exports.TREND_AXES = ['OCCASION', 'LAYOUT', 'FRAMEWORK', 'HOOK'];
/** Engine-facing facet ids (CLI `--facet`, S3 lake prefixes): the axes, lowercased. */
exports.TREND_ENGINE_FACETS = ['occasion', 'layout', 'framework', 'hook'];
/** Human labels for the axis selector. */
exports.TREND_AXIS_LABELS = {
    OCCASION: 'Moments',
    LAYOUT: 'Layouts',
    FRAMEWORK: 'Frameworks',
    HOOK: 'Hooks',
};
